module.exports = __webpack_public_path__ + "img/trash-can-sharp-light.f1495154.svg";